import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: { data: userType | null } = { data: null };

export const userSlice = createSlice({
   name: 'user',
   initialState,
   reducers: {
      reduxUpdateUser: (state, action: PayloadAction<userType>) => {
         state.data = action.payload;
      },
      reduxUpdatePrevUser: (state, action: PayloadAction<any>) => {
         state.data = { ...state.data, ...action.payload };
      }
   }
});

export const { reduxUpdateUser, reduxUpdatePrevUser } = userSlice.actions;
export default userSlice.reducer;